import Close from '@mui/icons-material/Close'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Tooltip, { TooltipProps } from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import I18n from 'i18n-js'
import { useState, useEffect } from 'react'

import PbxxLightbulbIcon from './PbxxLightbulbIcon'

const WhatIsThis: React.FC<
  React.PropsWithChildren<{
    item: string
    TooltipProps?: Omit<TooltipProps, 'title' | 'arrow' | 'open' | 'children'>
  }>
> = (props) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const isOpen = localStorage.getItem(`whatIsThis.${props.item}`) == null
    setIsOpen(isOpen)
  }, [props.item])

  const handleClose = () => {
    localStorage.setItem(`whatIsThis.${props.item}`, JSON.stringify(new Date()))
    setIsOpen(false)
  }

  return (
    <>
      <Tooltip
        {...props.TooltipProps}
        title={
          <Box display="flex" alignItems="top">
            <Typography variant="body1">{I18n.t(props.item)}</Typography>
            <div>
              <IconButton size="small" onClick={handleClose} color="inherit">
                <Close fontSize="small" />
              </IconButton>
            </div>
          </Box>
        }
        open={isOpen}
      >
        <IconButton
          color={isOpen ? 'primary' : undefined}
          onClick={() => {
            if (isOpen) {
              handleClose()
            } else {
              setIsOpen(true)
            }
          }}
          size="large"
        >
          <PbxxLightbulbIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}

export default WhatIsThis
